import { render, staticRenderFns } from "./NotFoundTab.vue?vue&type=template&id=98175292&"
import script from "./NotFoundTab.vue?vue&type=script&lang=js&"
export * from "./NotFoundTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports